// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"f796d589","354":"b3d665bd"}[chunkId] + ".chunk.js";
};